/**
 * The anonymous scan session id (localStorage `scan_session_id`), shared by the scan pages:
 * pages/ScanNew.jsx (flag off) and pages/public/ScanLanding.jsx (SLOT_MODEL, Phase 6c).
 * POST /api/scan/record dedupes on it (24 h per session + venue + design) and
 * POST /api/claims/email uses it to credit the scan with a claim (lib/claims.js reads the
 * same key). Moved here from ScanNew's inline code; the id format is unchanged.
 */
export const SCAN_SESSION_KEY = 'scan_session_id';

/** A new id: `session_<epoch ms>_<7 base-36 chars>` (ScanNew's format). */
export const newScanSessionId = () => `session_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;

/**
 * The stored session id, created and stored on first use. With storage blocked (private
 * mode, disabled cookies) a fresh id is returned for this call only.
 */
export function getScanSessionId() {
  try {
    const stored = window.localStorage.getItem(SCAN_SESSION_KEY);
    if (stored) return stored;
    const id = newScanSessionId();
    window.localStorage.setItem(SCAN_SESSION_KEY, id);
    return id;
  } catch {
    return newScanSessionId();
  }
}
